import React from "react";
import { Card } from "../core/Card";
import { Button } from "../core/Button";
import { FixyBeeMark } from "../brand/FixyBeeMark";

export function EmptyState({ title, body, primaryAction, secondaryAction, showBee = true, logoSrc }) {
  return (
    <Card padding="lg" style={{ textAlign: "center" }}>
      {showBee && (
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "var(--space-4)", opacity: .85 }}>
          <FixyBeeMark size={56} src={logoSrc} />
        </div>
      )}
      <p style={{
        fontFamily: "var(--font-display)", fontWeight: "var(--weight-semibold)",
        fontSize: "var(--text-lg)", color: "var(--text-body)",
      }}>{title}</p>
      {body && (
        <p style={{
          marginTop: "var(--space-2)", fontSize: "var(--text-sm)", color: "var(--text-muted)",
          maxWidth: "var(--measure-lede)", marginLeft: "auto", marginRight: "auto",
          lineHeight: "var(--leading-relaxed)",
        }}>{body}</p>
      )}
      <div style={{ marginTop: "var(--space-5)", display: "flex", gap: "var(--space-3)", justifyContent: "center", flexWrap: "wrap" }}>
        {secondaryAction && <Button variant="secondary" size="sm" onClick={secondaryAction.onClick}>{secondaryAction.label}</Button>}
        {primaryAction && <Button variant="primary" size="sm" onClick={primaryAction.onClick}>{primaryAction.label}</Button>}
      </div>
    </Card>
  );
}
